// extracted by mini-css-extract-plugin
module.exports = {"foto":"ComboResponsavel_foto__3VXH2"};